import React from "react";

/**
 * Bow Tie Kreative brand mark — circular black-and-white BTK seal/crest.
 * Uses the SVG asset for crisp scaling at any size; falls back to PNG.
 *
 * Default render: a gold-bordered circle wrapping the seal so it sits
 * comfortably alongside the "Bow Tie Kreative" wordmark on dark backgrounds.
 */
export default function BrandMark({ size = 36, className = "", testid = "brand-mark" }) {
  const PUB = process.env.PUBLIC_URL || "";
  return (
    <span
      data-testid={testid}
      className={`relative inline-flex items-center justify-center rounded-full overflow-hidden flex-shrink-0 ring-1 ring-gold/40 bg-white ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={`${PUB}/btk-logo.svg`}
        onError={(e) => { e.currentTarget.src = `${PUB}/btk-logo.png`; }}
        alt="Bow Tie Kreative"
        className="block w-full h-full object-contain p-[2px]"
      />
    </span>
  );
}
